import { DxDataGridComponent } from 'devextreme-angular';
import { ExcelService } from './../../shared/services/excel.service';
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { PaymentRequests } from "src/app/shared/models/paymentRequests";
import { PaymentrequestsService } from "src/app/shared/services/paymentrequests.service";
import { Subscription } from "rxjs";
import { UtilitiesService } from "src/app/shared/services/utilities.service";
import * as _ from "lodash";
import { User } from "src/app/shared/models/users";
import { Status } from "../../shared/enums/status.enum";
import { LiderStatus } from "../../shared/enums/lider-status.enum";
import { UsersService } from "../../shared/services/users.service";
import { CmgService } from "../../shared/services/cmg.service";


export class Attachment {
  url: string;
  fileName: string;
  is_ihunter: string;
}

@Component({
  selector: "app-payment-requests",
  templateUrl: "./payment-requests.component.html",
  styleUrls: ["./payment-requests.component.scss"],
})
export class PaymentRequestsComponent implements OnInit, OnDestroy {
  @ViewChild('dataGrid1') dataGrid: DxDataGridComponent;
  @ViewChild('dataGrid2') dataGrid2: DxDataGridComponent;
  private subscription$: Subscription = new Subscription();
  paymentRequest: PaymentRequests;
  datosCorreo: any;
  _subscriptions: Subscription[] = [];
  requests: any;
  facturaSuperlativeVisible: boolean = false;
  cdta: any;
  udta: User;
  files_list: Attachment[] = [];
  popupVisible: boolean = false;
  message: string;
  statusChangeObj: any;
  users_list: string = '';
  allUsers: any[] = [];
  statusList = [
    "Por Aceptar",
    "Aceptada",
    "Completada",
    "Cancelada",
    "Incidencia",
    "Programada",
    "Aprobada",
    "Rechazada"
  ]
  liderStatussObj = [
    {
      statusName: "Aprobada",
      status: Status.Aprobada,
    },
    {
      statusName: "Rechazada",
      status: Status.Rechazada,
    }
  ];
  applyFilterTypes = [
    {
      text: "Por aceptar",
      value: Status.PorAceptar,
    },
    {
      text: "Aceptada",
      value: Status.Aceptada,
    },
    {
      text: "Aprobada",
      value: Status.Aprobada,
    },
    {
      text: "Rechazada",
      value: Status.Rechazada,
    },
    {
      text: "Programada",
      value: Status.Programada,
    },
    {
      text: "Completada",
      value: Status.Completada,
    },
    {
      text: "Cancelada",
      value: Status.Cancelada,
    },
    {
      text: "Incidencia",
      value: Status.Incidencia,
    },
  ];
  statussObj = [
    {
      statusName: "Por aceptar",
      status: Status.PorAceptar,
    },
    {
      statusName: "Aceptada",
      status: Status.Aceptada,
    },
    {
      statusName: "Aprobada",
      status: Status.Aprobada,
    },
    {
      statusName: "Rechazada",
      status: Status.Rechazada,
    },
    {
      statusName: "Programada",
      status: Status.Programada,
    },
    {
      statusName: "Completada",
      status: Status.Completada,
    },
    {
      statusName: "Cancelada",
      status: Status.Cancelada,
    },
    {
      statusName: "Incidencia",
      status: Status.Incidencia,
    },
  ];

  constructor(
    private router: Router,
    private paymentrequestsService: PaymentrequestsService,
    private utilitiesService: UtilitiesService,
    private usersService: UsersService,
    private cmgService: CmgService
  ) {
    // this.cdta = this.utilitiesService.getCompanyData();
    // this.udta = this.utilitiesService.getUserData();
  }

  async ngOnInit() {
    this.cdta = this.utilitiesService.getCompanyData();
    this.udta = this.utilitiesService.getUserData();
    if (this.udta.level < 4) {
      this.facturaSuperlativeVisible = true;
    }
    console.log('this.udta',this.udta);
    
    this.getAllUsers();
    // this.getPaymentRequest();
  }

  getAllUsers(){
    this.usersService.getAllUsers().subscribe(res =>{
      this.allUsers = res;
      this.getPaymentRequest();
    });
  }
  getPaymentRequest(){
    this.subscription$.add(
      this.paymentrequestsService.getPaymentRequests(this.cdta.id, this.udta.level, this.udta.id).subscribe(
      (res: any) => {
        console.log(res);
        const result = res.data.reduce((a,e) =>{
          const user = this.allUsers.filter(f => f.uid == e.cmg.leader)
          e.cmg.leaderName = user[0] ? user[0].name : '';
          a.push(e)
          return a
        },[]);
        console.log('result',result);
        
        this.requests = result;
        this.files_list = res.data.attachments;
      },
      (error) => {
        console.log(error);
      }
      )
    );
  }

  addRequest() {
    this.router.navigate(["/dash/payment-requests/new"]);
  }

  changeStatus(e) {
    this.statusChangeObj.messages[0].liderStatusId = this.statusChangeObj.status != 2 ? null : this.statusChangeObj.messages[0].liderStatusId;
    if (e.validationGroup.validate().isValid) {
      this.subscription$.add(
        this.paymentrequestsService
          .updatePaymentRequestStatus(
            this.statusChangeObj.id,
            this.statusChangeObj.status,
            this.message,
            this.statusChangeObj.messages[0].liderStatusId
          )
          .subscribe((entry) => {
            this.utilitiesService.notifyMe("Status ha sido actualizado", "success");
            this.sendMails();
            this.getPaymentRequest();
            this.popupVisible = false;
            
          })
      );
    }
  }

  sendMails(){
    this.paymentrequestsService.getPaymentRequestEdit(this.statusChangeObj.id,'0').subscribe(request => {
      this.paymentRequest = request['payments_rows'][0];
      this.usersService.getUserAsPromise(this.paymentRequest.idCreatedBy).then(res => {
        this.datosCorreo = {
          ounerMail: res.email.trim(),
        }
        this.cmgService.getLiderListByCmgName(this.paymentRequest.cmg.cmg).subscribe(res => {
          if (res.length == 0) {
            this.datosCorreo.statusId = this.statusChangeObj.status;
            this.datosCorreo.liderStatus = this.statusChangeObj.messages[0].liderStatusId;
            this.datosCorreo.statusName = this.statusChangeObj.messages[0].liderStatusId == 1 ? this.statusList[6] : this.statusChangeObj.messages[0].liderStatusId == 2 ? this.statusList[7] : this.statusList[this.statusChangeObj.status -1];
            this.datosCorreo.message = this.message;
            this.datosCorreo.leaderMail = this.datosCorreo.statusName == 'Aprobada' ? 'dgarcia@sservices.com.mx' : this.datosCorreo.statusName == 'Rechazada' ? 'dgarcia@sservices.com.mx' : this.users_list;
            this.datosCorreo.paymentRequest = this.paymentRequest;
              this.paymentrequestsService.sendMails(this.datosCorreo).subscribe(res => {
                this.utilitiesService.notifyMe("Correo enviado, el CMG no cuenta con Lideres agregados", "warning");
              });
          }else{
            this.usersService.getListUsers(res).subscribe(res => {
              res.forEach(element => {
                this.users_list += (element.email + ',');
              });
                this.datosCorreo.statusId = this.statusChangeObj.status;
                this.datosCorreo.liderStatus = this.statusChangeObj.messages[0].liderStatusId;
                this.datosCorreo.statusName = this.statusList[this.statusChangeObj.status -1];
                this.datosCorreo.message = this.message;
                this.datosCorreo.leaderMail = this.datosCorreo.statusName == 'Aprobada' ? 'dgarcia@sservices.com.mx' : this.datosCorreo.statusName == 'Rechazada' ? 'dgarcia@sservices.com.mx' : this.users_list;
                this.datosCorreo.paymentRequest = this.paymentRequest;
              this.paymentrequestsService.sendMails(this.datosCorreo).subscribe(res => {
                this.utilitiesService.notifyMe("Correos enviados", "success");
              });
            });
          }
        });
      })
    });
    
  }

  openPopup(e) {
    this.message = '';
    this.statusChangeObj = e;
    this.popupVisible = true;
  }

  editRequest(id) {
    let URL = "/dash/payment-requests/edit/" + id;
    this.router.navigate([URL]);
  }

  getRecibo(data: any){
    this.paymentrequestsService.getRecibo(data).subscribe(res => {
      var pdf = res as ArrayBuffer;
      let file = new Blob([pdf], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);

      //Para descargar el PDF
      const downloadLink = document.createElement('a');
        downloadLink.href = fileURL;
        downloadLink.download = 'recibo.pdf';
        downloadLink.click();

      // Para ver el PDF en otra pestaña
      // window.open(fileURL);

      this.utilitiesService.notifyMe("Recibo Generado", "success");
    })
  }

  deleteFile(id: number){
    this.paymentrequestsService.deleteFile(id).subscribe(res => {
      this.utilitiesService.notifyMe("Se elimino el Archivo", "success");
      this.getPaymentRequest();
    })
  }

  export() {
    this.dataGrid2.instance.exportToExcel(false);
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
